export enum ROUTE_NAMES {
  app = 'app',
  notFound = 'app.not-found',
  home = 'app.home',
  blocks = 'app.blocks',
  blockDetails = 'app.blocks.block-details',
  transactions = 'app.transactions',
  transactionDetails = 'app.transactions.transaction-details',
  validators = 'app.validators',
  validatorDetails = 'app.validators.validator-details',
  accounts = 'app.accounts',
  accountDetails = 'app.accounts.account-details',
  charts = 'app.charts',
  chartsStats = 'app.charts.charts-stats',
  blockValidatorsChart = 'app.charts.block-validators-chart',
  averageOdinBlockSizeChart = 'app.charts.average-odin-block-size-chart',
  averageBlockTimeChart = 'app.charts.average-block-time-chart',
  dailyTransactionsVolumeChart = 'app.charts.daily-transactions-volume-chart',
  averageTransactionFeeChart = 'app.charts.average-transactions-fee-chart',
  totalRequestsChart = 'app.charts.total-requests-chart',
  ibc = 'app.ibc',
}
